import { DateTimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import Cte from "model/transportes/cte/Cte";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import CteService from "service/transportes/CteService";
import { numberToCnpj } from "utils/convert";

const cteService = new CteService();

export default function CteCadastro() {

    const [cte, setCte] = useState<Cte>(new Cte());

    function validar() {
        return false;
    }

    const titulo = "CTE";

    return <BaseCadastro model={cte}
        service={cteService}
        setModel={(value: Cte) => setCte(value)}
        validar={() => validar()}
        urlService="/cte"
        pathCadastro="/cte"
        tituloPagina={'CTE'}>

        {titulo ?
            <div className="row">
                <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
            </div>
            : null}

        <div className="row">
            <Label className="col col-sm-12">Chave CTE</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={cte.chCte}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Data e hora emissão</Label>
            <div className="col-sm-12">
                <DateTimePicker
                    readOnly
                    value={dayjs(cte.dhEmi)}
                    ampm={false}
                />
            </div>
            <Label className="col col-sm-12">Remetente</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={numberToCnpj(Number(cte.remetente?.cnpj))}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Destinatário</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={numberToCnpj(Number(cte.destinatario?.cnpj))}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Município início</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required
                    value={cte.xmunIni}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Município fim</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={cte.xmunFim}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Bairro</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={cte.destinatario?.enderDest.xBairro}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Logradouro</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={cte.destinatario?.enderDest.xLgr}
                    style={{ width: '30%' }}
                />
            </div>
            <Label className="col col-sm-12">Número</Label>
            <div className="col-sm-12">
                <InputText
                    readOnly
                    required value={cte.destinatario?.enderDest.nro + ""}
                    style={{ width: '30%' }}
                />
            </div>
        </div>

    </BaseCadastro>
}